import React from 'react'
import './stats-style.scss';

function StatsPoint({title:Title,subTitle}) {
  return (
    <div className="stats-box stat-box-pad-lft">
            <div className="stats-title"><Title/></div>
            <p className="stats-text">{subTitle}</p>
          </div>
  )
}

export default StatsPoint